<div ngbDropdown class="d-inline-block right-aligned">
  {{userName}}
  <button
    class="btn btn-transparent dropbtn"
    id="dropdownBasic1"
    ngbDropdownToggle
  >
    <i class="fa fa-bars"></i>
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
    <button
      ngbDropdownItem
      *ngFor="let navigation of navigations"
      (click)="onNavigationClicked(navigation.route)"
    >
      {{ navigation.title }}
    </button>
  </div>
</div>
